<template>
    <body>
    <h1>Составы</h1>
    <p>{{prevMatchday}} тур</p>
    <v-list align="start"
            dense>
        <v-list-group
                dense
                v-for="team in this.teams"
                :key="team.title"
                no-action>
            <template v-slot:activator>
                <v-list-item>
                    <v-row class="hidden-sm-and-down">
                        <v-col >
                            <v-list-item-title v-text="team.title"></v-list-item-title>
                        </v-col>
                    </v-row>

                <v-container align-start class="hidden-md-and-up column_sm">
                            <v-list-item-title class="cell_sm" v-text="team.title"></v-list-item-title>
                </v-container>
                </v-list-item>
            </template>
            <v-list>
                <v-list-item class="row-cell"
                        v-for="player in team.players"
                        :key="player.name">
                    <v-layout raw class="hidden-md-and-up">
                        <v-list-item-title class="pos-cell_sm ps-12 row list">{{player.pos}}</v-list-item-title>
                        <v-list-item-title class="cell_sm ps-4 pe-12 row ">{{player.name}}</v-list-item-title>
                        <v-list-item-title class="cell_sm">{{player.realTeam}}</v-list-item-title>
                    </v-layout>
                    <v-layout raw class="hidden-sm-and-down">
                        <v-list-item-title class="pos-cell ps-12 row list">{{player.pos}}</v-list-item-title>
                        <v-list-item-title class="cell ps-4 pe-12 row ">{{player.name}}</v-list-item-title>
                        <v-list-item-title class="cell">{{player.realTeam}}</v-list-item-title>
                    </v-layout>
                </v-list-item>
            </v-list>

        </v-list-group>
    </v-list>

    </body>
</template>

<script>
    export default {
        props: ["teams", "prevMatchday"],
        data() {
            return {
                teamsData: []
            }
        }
    }
</script>

<style>
    .last_update{
        text-align: end;
        font-size: 8pt !important;
    }
    .column_sm{
             align-content: start !important;
    }
    .cell{
        min-width: 20%;
        width: 200px;
        max-width: 100%;
        text-align: start;
    }
    .cell_sm{
        font-size: 8pt !important;
        min-width: 20%;
        width: 200px;
        max-width: 100%;
        text-align: start;
    }
    .row-cell {
        min-height: 0px !important;
        height: 20px !important;
        max-height: 50px !important;
    }
    .pos-cell{
        min-width: 100px;
        width: 100px;
        max-width: 100%;
        text-align: start;
    }
    .pos-cell_sm{
        font-size: 8pt !important;
        min-width: 85px;
        width: 100px;
        max-width: 100%;
        text-align: start;
    }

</style>

